"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.camel2kebab = camel2kebab;

/**
 *  Utilities
 */
function camel2kebab(str) {
  return String(str).replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
}
//# sourceMappingURL=util.js.map